import React, { useRef, useState } from "react";
import "./Investments.css";
import logoSrc from "../img/logo.png";
import ContactForm from "../ContactForm"; // Make sure this component has the `openForm` method.

function InvestInYourIdeaForm() {
  const contactFormRef = useRef(); // Reference for controlling the contact form

  // Snackbar state
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarVisible, setSnackbarVisible] = useState(false);

  // Function to open the contact form
  const handleOpenContactForm = () => {
    if (contactFormRef.current) {
      contactFormRef.current.openForm(); // Ensure the `ContactForm` has this method.
    }
  };

  // Handle Snackbar visibility
  const showSnackbar = (message) => {
    setSnackbarMessage(message);
    setSnackbarVisible(true);
    setTimeout(() => setSnackbarVisible(false), 3000); // Hide after 3 seconds
  };

  const handleSubmit = async (event) => {
    event.preventDefault(); // Prevent default form submission

    const formData = new FormData(event.target); // Create FormData object from the form

    try {
      const response = await fetch(
        "https://apiqms.shigjeta.com/api/forms/invest-ideas/submit",
        {
          method: "POST",
          body: formData,
        }
      );

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const result = await response.json();
      showSnackbar(result.message || "Investment form submitted successfully!");
    } catch (error) {
      console.error("Error submitting form:", error);
      showSnackbar(
        "There was an error submitting your form. Please try again."
      );
    }
  };

  // Snackbar styling
  const snackbarStyle = {
    position: "fixed",
    top: "20px", // Move it to the top
    left: "50%", // Center horizontally
    transform: "translateX(-50%)", // Adjust to perfectly center
    backgroundColor: snackbarMessage.includes("success")
      ? "#16a085"
      : "#e74c3c",
    color: "white",
    padding: "15px 30px",
    borderRadius: "8px",
    fontSize: "16px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
    zIndex: 1001,
    animation: "fadeIn 0.5s ease-out",
  };

  const dismissButtonStyle = {
    background: "none",
    border: "none",
    color: "white",
    fontSize: "16px",
    cursor: "none",
    fontWeight: "bold",
    marginLeft: "15px", // Adds a gap between the text and the button
  };

  return (
    <>
      {/* Hero Section */}
      <div className="banner-logo" id="sectionBanner1">
        {logoSrc && <img src={logoSrc} alt="Shigjeta Logo" />}
      </div>

      <section className="banner-section" id="sectionBanner">
        <div className="banner-container">
          <div className="banner-text">
            <h1 className="banner-title">
              Bring your vision to life and make it real
            </h1>
            <p className="banner-description">
              Fill out the form and take the first step in turning your idea
              into a successful venture.
            </p>
            <a
              onClick={handleOpenContactForm} // Open the form on button click
              className="banner-button"
            >
              Start Now
            </a>
          </div>
          <div className="shop-hero-background"></div>
        </div>
      </section>

      <div className="img-background">
        <img
          className="img"
          id="banner1-video"
          src="/img/Invest in MVPThumbnail.png" // This should be correct if the video is in the public folder
          autoPlay
          muted
          loop
          playsInline
          onError={(e) => console.error("Error loading video:", e)} // Error logging for debugging
        />
      </div>

      <h3 className="textForm">Shigjeta LLC - Invest in Your Idea</h3>

      {/* Invest in Your Idea Form */}
      <section className="contract-form-container">
        <form onSubmit={handleSubmit} className="contract-form">
          <div className="divFlexField">
            <div className="form-group">
              <label>Full Name</label>
              <input type="text" id="fullName" name="fullName" required />
            </div>
            <div className="form-group">
              <label>Email</label>
              <input type="email" id="email" name="email" required />
            </div>
          </div>

          <div className="divFlexField">
            <div className="form-group">
              <label>Phone Number</label>
              <input type="text" id="phone" name="phone" required />
            </div>
            <div className="form-group">
              <label>Country/Region</label>
              <input
                type="text"
                id="countryRegion"
                name="countryRegion"
                required
              />
            </div>
          </div>

          <div className="divFlexField">
            <div className="form-group">
              <label>Idea Name</label>
              <input type="text" id="ideaName" name="ideaName" required />
            </div>
            <div className="form-group">
              <label>Industry</label>
              <select id="industry" name="industry" required>
                <option value="">Select...</option>
                <option value="Technology">Technology</option>
                <option value="Healthcare">Healthcare</option>
                <option value="Education">Education</option>
                <option value="Renewable Energy">Renewable Energy</option>
              </select>
            </div>
          </div>

          <div className="form-group">
            <label>Describe Your Idea</label>
            <textarea id="describeYourIdea" name="describeYourIdea" required />
          </div>

          <div className="form-group">
            <label>Stage of Development</label>
            <select id="stageOfDevelopment" name="stageOfDevelopment" required>
              <option value="">Select...</option>
              <option value="Concept">Concept</option>
              <option value="Prototype">Prototype</option>
              <option value="MVP">MVP</option>
              <option value="Market-Ready">Market-Ready</option>
            </select>
          </div>

          <div className="form-group">
            <label>What Makes Your Idea Unique?</label>
            <textarea id="uniqueIdea" name="uniqueIdea" required />
          </div>

          <div className="form-group">
            <label>Investment Required</label>
            <input
              type="text"
              id="investmentRequired"
              name="investmentRequired"
              required
            />
          </div>

          <div className="form-group">
            <label>Expected ROI</label>
            <input type="text" id="expectedROI" name="expectedROI" required />
          </div>

          <div className="form-group">
            <label>Attachments (Business Plan, Pitch Deck, etc.)</label>
            <input type="file" id="attachments" name="attachments" />
          </div>

          <div className="form-group">
            <label>How Can Our Platform Help You?</label>
            <textarea id="howCanOurPlatformHelp" name="howCanOurPlatformHelp" />
          </div>

          <div className="form-group">
            <label>Questions/Comments</label>
            <textarea id="questionsComments" name="questionsComments" />
          </div>

          <button type="submit" className="submit-button">
            Submit Your Idea
          </button>
        </form>
      </section>
      {/* Snackbar */}
      {snackbarVisible && (
        <div style={snackbarStyle}>
          {snackbarMessage}
          <button
            style={dismissButtonStyle}
            onClick={() => setSnackbarVisible(false)}
          >
            Dismiss
          </button>
        </div>
      )}

      <ContactForm ref={contactFormRef} />
    </>
  );
}

export default InvestInYourIdeaForm;
